var cropper = {};
var container_width;
var container_height;
// var modal_margin_left;
var list_of_uploaded_images = [];
var cancelledAmount = 0;
var filesAmount = 0;
var _cropper;


// window.$amazon = {
//     input: '#amazon-upload-images',
//     multiple: true,
//     frame: 3/2,
//     type : '',
//     urls: [],
//     data: {},
//     callback: {}
// }


$(document).ready(function(){
    // initial processing
    get_size_container();
    init_upload_modal();

    // upload restaurant images
    $('#amazon-upload-images').on('click', function() {
        $('#amazon-upload-images').val('');
        if(!window.$amazon.multiple) $('#amazon-upload-images').removeAttr('multiple');
    });
    $('#amazon-upload-images').on('change', function() {
        if(!window.$amazon.multiple) $('#amazon-upload-images').removeAttr('multiple');
        upload_images(this);
    });
    $('#modal-upload-images').on('click','.submit-image',function() {
    const target = $(this);

    //   target.prop('disabled', true);
    //   target.data('text', target.text());
        //   target.text('Uploading...');
    $('#list-of-uploaded-images').addClass("d-none");
    $('#newPhoto').addClass("d-none");
    $('#upload-images-loading').addClass("d-flex flex-column")
      let key = target.data('key');
      upload_images_to_amazons3(key)
        .then((success)=>{
          window.$amazon.callback[$amazon.type]();
        })
        .then(()=> {
            $('#upload-images-loading').removeClass("d-flex flex-column")
        })
        .catch(e => {
          // ********  DEBUG - NOTIFY DEV TEAM ( this will be deleted after the issue is fixed)
          console.log(e);
          try {
            $.ajax({
              url: '/notify-dev-team',
              method: 'POST',
              dataType: 'json',
              data: {
                subject: "after calling upload_images_to_amazons3",
                payload: e,
                payloadJSONStringified: JSON.stringify(e)
              },
            })
          } catch(e) {}
          // ********  DEBUG - NOTIFY DEV TEAM ( this will be deleted after the issue is fixed)

          Swal.fire({
            title: "Unable to upload!",
            text: "There is an internet connection problem.",
            icon: "error",
          });
          target.prop('disabled', false);
          target.text(target.data('text'));
          $('#upload-images-loading').removeClass("d-flex flex-column")

        });
    })
    $('#modal-upload-images').on('click','.cancel-image',function(){
        let key = $(this).data('key');
        $(`#image-${key}`).remove();
        cancelledAmount ++;
        $('#number-of-cancelled-images').text(`Cancelled: ${cancelledAmount}/${filesAmount}`);
        upload_compeltely(false);
    })
    //for rotate button click
    $('#modal-upload-images').on('click','#image-rotate-right',function(){
        let key = $(this).data('key');
        let photo = $('#list-of-uploaded-images').find(`#upload-image-${key}`);
         _cropper = photo[0].cropper;
         _cropper.rotate(90);
    })
    $('#modal-upload-images').on('click','#image-rotate-left',function(){
        let key = $(this).data('key');
        let photo = $('#list-of-uploaded-images').find(`#upload-image-${key}`);
         _cropper = photo[0].cropper;
         _cropper.rotate(-90);
    })
})

// ------------------------------------------------------------

var upload_images_to_amazons3 = function (key) {
  return new Promise((resolve, reject) => {
    let image_data = cropper[key]['img'].getCroppedCanvas().toDataURL(cropper[key]['type'], cropper[key]['quality']);
    const data = { images: [image_data] };
    $.ajax({
      url: '/upload-images-to-amazons3',
      method: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(data),
    })
    .then(res => {
      window.$amazon.urls = res.data;
      list_of_uploaded_images = list_of_uploaded_images.concat(res.data);
      $('#number-of-uploaded-images').text(`Uploaded: ${list_of_uploaded_images.length}/${filesAmount}`);
      let html = `
        <img src="${image_data}" class="img-thumbnail mr-3" style="width: 100px !important;">
      `;
      $(`#list-of-uploaded-successfully`).prepend($(html))
      $(`#image-${key}`).remove();
      upload_compeltely();
      $('#list-of-uploaded-images').removeClass("d-none");
      $('#newPhoto').removeClass("d-none");
      return resolve(res.data);
    })
    .catch((e) => {
      // ********  DEBUG - NOTIFY DEV TEAM ( this will be deleted after the issue is fixed)
      console.log(e);
      try {
        $.ajax({
          url: '/notify-dev-team',
          method: 'POST',
          dataType: 'json',
          data: {
            subject: "inside calling upload_images_to_amazons3",
            payload: e,
            payloadJSONStringified: JSON.stringify(e)
          },
        })
      } catch(e) {}
      // ********  DEBUG - NOTIFY DEV TEAM ( this will be deleted after the issue is fixed)
      return reject(new Error('File upload failed!'));
    })
  })
}

function upload_compeltely(upload = true){
    let total_images = Number(list_of_uploaded_images.length) + Number(cancelledAmount);
    if(total_images != Number(filesAmount)) return false;
    setTimeout(function(){
        $('#modal-upload-images').iziModal('close');
        $('#list-of-uploaded-images').html('');
        $('#number-of-uploaded-images').text('');
        $('#number-of-cancelled-images').text('');
        if(upload) {
            $('#modal-upload-images').iziModal('close');
            $('#upload-temporary-menu').iziModal('close');
            toastr.success('Upload Completed');
        }
        else{
            $('#modal-upload-images').iziModal('close');
            $('#upload-temporary-menu').iziModal('close');
            toastr.success('Upload Cancelled');
        } 
    }, 1000)
}

function get_size_container(){
    let screen_width = 620;
    if(screen_width < 500){
        // container_width = screen_width * 0.8;
        // modal_margin_left = 10;
    }else{
        // container_width = screen_width * 0.5;
        // modal_margin_left = 20;
    }  
    container_height =   container_width * 9 / 16;
}

function init_upload_modal(){
    let html = `
        <div class="row col-xs-12 col-sm-12 col-md-12" style="display: none;">
            <input type="file" id="amazon-upload-images" ${window.$amazon.multiple ? 'multiple' : ''}>
        </div>
        <div id="modal-upload-images" class="card" style="display: none;">
            <div class="card-body">
                <div class="d-flex justify-content-between" style="font-size: 20px; font-weight: bolder;">
                    <div id="number-of-uploaded-images"></div>
                    <div id="number-of-cancelled-images"></div>
                    <div id="close-upload-modal"><i class="fa fa-times" aria-hidden="true" style="font-size: 35px;"></i></div>
                </div>
                <div id="uploading-spinner" class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                </div>
                <p id="newPhoto" style="margin:auto;font-weight: 500;font-size: 22px;color: #4A4A4A;text-align: center;">New Photo</p>
                <div id="list-of-uploaded-successfully" class="d-flex justify-content-start" style="overflow-x: auto;">                    
                </div>
                <div id="list-of-uploaded-images">
                </div>
                <div id="upload-images-loading" class="d-none" style="width:100%; height: 300px; text-align: center">
                    <div class ="col-lg-10 col-sm-8 ">
                        <img style="width: 50%" class="statusUploadImages" src="/images/upLoadingImages.svg"></img>
                    </div>
                    <div>
                        <img class="iconUploadImages"  src="/images/Vector@2x.svg"></img>
                    </div>
                    <h5 style="color: green;font-size: 30px;" >Loading...</h5>
                    <p>Upload times will depend on the speed of your internet connection</p>
                </div>
            </div>
        </div>
    `;
    $('body').append(html);
    $("#modal-upload-images").iziModal({
        width: 590,
        zindex: 9999,
        onOpening: function(){
            cropper = {};
            list_of_uploaded_images = [];
            cancelledAmount = 0;
            filesAmount = 0;
        },
        onClosing: function(){
            $amazon.finished()
        },
        onClosed: function(){
            $('#list-of-uploaded-images').html('');
            $('#number-of-uploaded-images').text('');
            $('#number-of-cancelled-images').text('');
            $(`#list-of-uploaded-successfully`).html('')
        }
    });
    
    $('#close-upload-modal').on('click',function(){
        $('#modal-upload-images').iziModal('close');  
    })
}

var upload_images = function(input) {
    let files
    if (input && input.files) {
        files  = input.files
    }else{
        files = $amazon.files
    }
    if(!files) return false

    if(!$.validateImage({name : files[0].name, size: files[0].size})) {
        return Swal.fire({
            title: "Invalid File Format",
            text: "You can only upload images on JPG, JPEG, PNG, GIF, or BMP formats. Image size less than 50MB",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#3cb371",
        });
    }

    let max_size = $amazon.size || 1000000
    $('#uploading-spinner').show()
    $('#modal-upload-images').iziModal('open');
    filesAmount = files.length;
    for (let i = 0; i < filesAmount; i++) {
            let img_type = 'image/jpeg'
            let up_file = files[i]
            if(up_file.size <= max_size) img_type = up_file.type
            let reader = new FileReader();
            reader.onload = function() {
                let canvas = document.createElement("canvas");
                let context = canvas.getContext('2d');
                let img = new Image();
                img.onload = function() {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    context.clearRect(0, 0, canvas.width, canvas.height)
                    context.drawImage(img, 0, 0, canvas.width, canvas.height)

                    let base_img
                    let quality = 1
                    if(up_file.size <= max_size){
                        base_img = canvas.toDataURL(img_type, 1)
                    }else{
                        for(quality = 1; quality >= 0.1; quality-=0.1) { 
                            base_img = canvas.toDataURL('image/jpeg', quality)
                            let img_size = calculate_image_size(base_img)
                            if(img_size <= 1000) break
                        }
                    }

                    let key = Math.random().toString(36).substring(2)
                    let html = `
                            <div id="image-${key}" style="padding-top: 20px;">
                                <div style="max-height: 40vh">
                                    <img id="upload-image-${key}" style="width: 100% !important; border-radius: 10px;" src="${base_img}">
                                </div>
                                <div class="btn-image-rotate form-inline justify-content-between mt-3" style="background: rgba(233,233,233,0.5);">
                                    <a class="m-2 ml-3" id="image-rotate-left" href="javascript:void(0)" data-key="${key}">
                                        <img src="/images/rotate_left_24px.png" style="width: 25px"/>
                                    </a>
                                    <a class="m-2 mr-3" id="image-rotate-right" href="javascript:void(0)" data-key="${key}">
                                        <img src="/images/rotate_right_24px.png" style="width: 25px"/>
                                    </a>
                                </div>
                                <div class="mt-3">                                    
                                    <button class="btn btn-success btn-block submit-image" data-key="${key}">Submit</button>
                                </div>
                                <div class="mt-3">
                                    <button class="btn btn-outline-danger btn-block cancel-image" data-key="${key}">Cancel</button>
                                </div>
                            </div>
                    `;
                    $('#list-of-uploaded-images').append(html);
                    let photo = $('#list-of-uploaded-images').find(`#upload-image-${key}`);
                    crop_photo(photo, key, img_type, quality);
                }
                img.src = reader.result;
                if(i == filesAmount - 1) {
                    setTimeout(()=>{
                        $('#uploading-spinner').hide()
                    }, 1000)
                }
            }
            reader.readAsDataURL(files[i]);
    }
};

const crop_photo = function(image, key, type = 'image/jpeg', quality = 1){
    cropper[key] = {}
    image = new Cropper(image[0], { 

         aspectRatio: window.$amazon.frame || 3/2,
        viewMode: 0,

        // minContainerWidth: container_width,
        // minContainerHeight: 400,
        background: false,
        /* autoCrop: true, */
        // autoCrop: true,
        // autoCropArea: 1,
        // aspectRatio: 590 / 400,
        // minCropBoxWidth: 590,
        // minCropBoxHeight: 400,
        // viewMode: 2,
        // ready: function() {
            // generatePreview();
        // },
        crop: function(event) {
            // console.log(event);
        },
    });
    cropper[key]['img'] = image;
    cropper[key]['type'] = type
    cropper[key]['quality'] = quality
}

// 
let calculate_image_size = (base64String)=>{
    let padding, inBytes, base64StringLength;
    if(base64String.endsWith("==")) padding = 2;
    else if (base64String.endsWith("=")) padding = 1;
    else padding = 0;

    base64StringLength = base64String.length;
    inBytes =(base64StringLength / 4 ) * 3 - padding;
    return inBytes / 1000
  }

window.$amazon.handler = upload_images
//   
